import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import PopupLoader from './utils/PopupLoader';
import msg from '../utils/msgToask';
import utilsRecervas from '../utils/utilsRecervas';
import Modal from 'react-bootstrap/Modal';

const restricciones_desactivadas = process.env.REACT_APP_RESTRICCIONES_DESACTIVADAS === "true";

function PaginaURL() {

    const navigate = useNavigate()
    const { regional, id_sucursal, piso} = useParams();
    const [loading, setLoading] = useState(false);
    const [mostrarAdvertencia, setMostrarAdvertencia] = useState(false);
    const [mensajeAdvertencia, setMensajeAdvertencia] = useState("");

    const selectSucursal = async (id_sucursal, id_regional) => {
        var idSucursal = id_sucursal;
        await getMenuSucursal(idSucursal, id_regional);
    }

    async function getMenuSucursal(idSucursal, idRegional) {

        let sucursalesActivas;

        try {
            const respuesta1 = await fetch(`/sucursales/configuracionHorarios`);
            const data1 = await respuesta1.json();
            if (data1.ok) {
                localStorage.setItem("configHR", JSON.stringify(data1.ok[0]));
                sucursalesActivas = utilsRecervas.getListaSucursalesActivos();

                if (!sucursalesActivas.includes(idSucursal) || idSucursal == 11 || idSucursal == 39 ) {
                    console.log("Sucursal inactiva")
                    localStorage.removeItem('configHR');
                    //localStorage.clear();
                    navigate("/", { replace: true });
                    return;
                }

                var infor = utilsRecervas.getHorarioSucursalRegional(idRegional, 9);

                if (restricciones_desactivadas || (infor[3] !== '0' && infor[3] != '1')) {
                    if (restricciones_desactivadas || (infor[8].indexOf('R') != -1)) {

                        const respuesta2 = await fetch(`/sucursales/regional/${idRegional}`);
                        const data2 = await respuesta2.json();

                        localStorage.setItem("sucursales", JSON.stringify(data2.sucursales));
                        localStorage.setItem("menucategorias", JSON.stringify(data2.menuCategoria));
                        localStorage.setItem("menuApp", JSON.stringify(data2.menuApp));
                        localStorage.setItem('ciudad', idRegional);
                        localStorage.setItem('filtroCategoria', -100);
                        localStorage.setItem("filtroSucursal", idSucursal);
                        localStorage.setItem('tipoPedido', 'SUCURSAL');

                        var aux = new Date()
                        var hora = aux.getHours() < 10 ? '0'.concat(aux.getHours()) : aux.getHours();
                        var minutes = aux.getMinutes() < 10 ? '0'.concat(aux.getMinutes()) : aux.getMinutes();

                        if (restricciones_desactivadas || validarOpenSucursal(idSucursal, (hora + ':' + minutes).split(':'))) {

                            const respuesta3 = await fetch(`/productos/menuSucursalRegional`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                },
                                body: JSON.stringify({ regional, idSucursal })
                            });

                            const data3 = await respuesta3.json();

                            localStorage.setItem("listamenu", JSON.stringify(data3));
                            localStorage.setItem('pedidoConRuta', true);
                            localStorage.setItem("confirmacionRealizadaEnlace", 'false');
                            localStorage.removeItem('carrito');

                            localStorage.setItem("idSucursal", idSucursal);
                            localStorage.setItem("pisoSeleccionado", piso);
                            //localStorage.removeItem('informacionCliente');

                            setLoading(false);
                            navigate("/menu", { replace: true });

                        } else {
                            setMostrarAdvertencia(true);
                        }

                    } else {
                        setMensajeAdvertencia(`No estamos permitiendo, pedidos recogera de sucursal en ${idRegional == '990' ? 'COCHABAMBA' : 'SANTA CRUZ'}, intente mas tarde por favor ...`)
                        setMostrarAdvertencia(true);
                    }
                } else {
                    setMensajeAdvertencia(`No estamos permitiendo pedidos en ${idRegional == '990' ? 'COCHAMBAMBA' : 'SANTA CRUZ'}, gracias Intente mas tarde por favor ...`)
                    setMostrarAdvertencia(true);
                }
            }else{
                throw new Error(`Error del servidor: ${respuesta1.status}`);
            }

        } catch {
            setMensajeAdvertencia(`Ocurrio un error, intente mas tarde por favor.`)
            setMostrarAdvertencia(true);
        }

        /* 
        await fetch(`/sucursales/configuracionHorarios`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    console.log(data.ok)
                    localStorage.setItem("configHR", JSON.stringify(data.ok[0]));
                    sucursalesActivas = utilsRecervas.getListaSucursalesActivos();
                    localStorage.removeItem('carrito');

                } else {
                    console.log("ERROR")
                    //setMessage("Intente nuevamente mas tarde por favor...");
                    //setAlerta(true);
                }
            })
            .catch(err => {
                console.log("ERROR", err.message)
                navigate("/", { replace: true });
                //setMessage("error", err.message);
                //setAlerta(true);
            });
        
        await fetch(`/sucursales/regional/${idRegional}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(data => {

                localStorage.setItem("sucursales", JSON.stringify(data.sucursales));
                localStorage.setItem("menucategorias", JSON.stringify(data.menuCategoria));
                localStorage.setItem("menuApp", JSON.stringify(data.menuApp));
            })
            .catch(err => {
                console.log(err);
                msg.msgError(err.message)
            });

        await fetch(`/productos/menuSucursalRegional`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ regional, idSucursal })
        })
            .then(res => res.json())
            .then(data => {
                localStorage.setItem("listamenu", JSON.stringify(data));
                localStorage.setItem("filtroSucursal", idSucursal);
                localStorage.setItem('ciudad', idRegional);
                localStorage.setItem('tipoPedido', 'SUCURSAL');
                localStorage.setItem('filtroCategoria', -100);
                localStorage.setItem('pedidoConRuta', true);
                localStorage.setItem("confirmacionRealizadaEnlace", 'false');

                localStorage.setItem("idSucursal", idSucursal);
                //localStorage.removeItem('informacionCliente');

                setLoading(false);

                //navigate("/menu", { replace: true });
            })
            .catch(err => {
                console.log(err);
                msg.msgError(err.message)
            });
        */
    }

    function validarOpenSucursal(suc, hora) {
        var infor = utilsRecervas.getHorarioSucursalRegional(regional, 9);

        var hro = 0, hrc = 0
        if (infor[infor.indexOf(3)] != 0) {
            hro = infor[4];
            hrc = infor[5];
        }
        var info = utilsRecervas.getHorarioSucursal(9)
        var horaIni = info[info.indexOf(suc) + 1];
        var horaFin = info[info.indexOf(suc) + 2];
        var dayminutes = (parseInt(hora[0]) * 60) + parseInt(hora[1]);

        if ((dayminutes >= horaIni && (hro == 0 || dayminutes >= hro)) && (dayminutes < horaFin && (hrc == 0 || dayminutes < hrc))) {
            return true;
        } else {
            console.log("hora no valida");
            var sucursalname = utilsRecervas.getNombreSucursal(suc);
            var info = utilsRecervas.getHorarioSucursal(suc)
            var horaIni = Math.trunc(info[info.indexOf(suc) + 1] / 60);
            var horaFin = Math.trunc(info[info.indexOf(suc) + 2] / 60);
            setMensajeAdvertencia("El pedido para la sucursal " + sucursalname + " es permitido entre " + horaIni + ' - ' + horaFin + ' Horas.')
            return false;
        }
    }

    useEffect(() => {
        setLoading(true);
        selectSucursal(id_sucursal, regional);
    }, [])

    return (
        <>
            <PopupLoader loading={loading} />

            <Modal show={mostrarAdvertencia} contentClassName="bg-transparent "
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header bsPrefix="modal-header m-0 p-0">
                    <div className='verPedidoButon w-100 text-center my-auto py-1'
                        style={{ borderTopRightRadius: '10px', borderTopLeftRadius: '10px' }}>
                        <div className='text-white textTitle'><i className="fa-solid fa-circle-exclamation"></i> NOTIFICACIÓN</div>
                    </div>
                </Modal.Header>
                <Modal.Body bsPrefix="modal-body m-0 p-0 bg-light">
                    <div className='container-fluid py-4'>
                        <p className='textInfo text-center mb-1'><i className="fa-solid fa-triangle-exclamation fa-2xl fa-fade"></i>
                            {mensajeAdvertencia}
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer bsPrefix="modal-footer text-center m-0 p-0 mx-auto bg-light w-100">
                    <Link className="btn btn-sm text-light botonNaranja" to='/' onClick={() => { setMostrarAdvertencia(false) }}>
                        Aceptar
                    </Link>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default PaginaURL;